import { useHistory } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';
import jsCookie from 'js-cookie';
import { logger } from 'RootShared/utility/ErrorLogger';
import { useMutation, gql } from '@apollo/client';

const mutationLogOut = gql`
  mutation ProfileLogOutMutation @api(name: root) {
    logout {
      result
    }
  }
`;

export default () => {
  const history = useHistory();
  const client = useApolloClient();

  const logOutUser = () => {
    jsCookie.remove('isAuthenticated');
    sessionStorage.removeItem('initialPathName');
    client.clearStore();

    const userType = localStorage.getItem('userType') || 'employee';
    history.push(`/login/${userType}/`);
    window.location.reload();
  };

  const logOutUserError = (error) => {
    logger.error(error);
    jsCookie.remove('isAuthenticated');
    history.push('/login/');
  };

  const mutationResult = useMutation(mutationLogOut, {
    onCompleted(data) {
      const {
        logout: { result },
      } = data;

      if (result) {
        logOutUser();
      }
    },
    onError: logOutUserError,
  });

  return mutationResult;
};
